/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import BarraPc from "./BarraPc";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {theme} from "../../Tema";
import IconoTexto from "./Componentes/IconoTexto";
import {LocationOn, WhatsApp} from '@mui/icons-material'
import {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {obtenerSeccion} from "../../Utilidades/obtenerSeccion";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";


const Barra = () => {
    const {sCell, masSM} = useResponsive()
    const [esVerde, setEsVerde] = useState(true);
    const location = useLocation();
    const [rutas, setRutas] = useState([]);


    useEffect(() => {
        obtenerCol('rutas').then((dox) =>{
            if (dox.res){
                setRutas(dox.data)
            }
        })
    }, []);

    useEffect(() => {

        let path = location.pathname;
        let seccion = obtenerSeccion(path);

        let arrNoVerde = ['Detalle']
        setEsVerde(arrNoVerde.includes(seccion));

    }, [location])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: '#fff',
                        pt: 0.8,
                        pb: 1.1,
                        px: 2
                    }}
                >

                    {masSM &&
                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <IconoTexto Icono={LocationOn} texto={'Argentina - Buenos Aires'}/>
                        </Grid>
                    }

                    {rutas.length > 0 &&
                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center'}}>
                            <Splide
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage: 1,
                                    arrows: false,
                                    pagination: false,
                                    width: '100%',
                                    drag: 'false',
                                    interval: 8000,
                                    noDrag: true,
                                    type: 'loop',
                                    gap: 20,

                                }}
                            >

                                {rutas.map((it, index) => {
                                    return (
                                        <SplideSlide key={`qe${index}`}>
                                            <Grid
                                                container
                                                justifyContent={'center'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}>

                                                <Typography
                                                    sx={{fontSize: 13, textAlign: 'center',}}
                                                >
                                                <span style={{
                                                    backgroundColor: theme.palette.secondary.main,
                                                    color: '#fff',
                                                    paddingLeft: 10,
                                                    paddingRight: 10,
                                                    borderRadius: 10,
                                                    paddingBottom: 2,
                                                    marginRight: 5,
                                                }}>
                                                    Gratis
                                                </span>
                                                    {`Envio gratis si compras superiores a ${formatoMoneda(it.valorGratis)} `}
                                                    <span style={{
                                                        color: theme.palette.secondary.main,
                                                        fontWeight: 600,
                                                        fontSize: 14
                                                    }}>{it.nombre}</span>
                                                </Typography>

                                            </Grid>
                                        </SplideSlide>
                                    )
                                })}


                            </Splide>
                        </Grid>
                    }

                    {masSM &&
                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                            <IconoTexto Icono={WhatsApp} texto={'+54 911 3388 1508'}/>
                        </Grid>
                    }

                </Grid>
            </Grid>

            {masSM ?
                <BarraPc esVerde={esVerde}/>
                :
                <BarraCell/>
            }


        </Grid>
    )

}
export default Barra

